import { render, staticRenderFns } from "./updateModal.vue?vue&type=template&id=6acba75c&"
import script from "./updateModal.vue?vue&type=script&lang=js&"
export * from "./updateModal.vue?vue&type=script&lang=js&"
import style0 from "./updateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports